module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Britannia-S1.e63e8f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Britannia-S1.jpg
// module id = kwtq
// module chunks = 0